import { useState } from "react";
import { useSearchParams } from "react-router-dom";

import { CreateEmployeeWizard } from "../../components/features/create-employee/create-employee-wizard.tsx";
import { useSqeOnboardingApi } from "../../components/features/onboarding/sqe/sqe-onboarding-link-context.tsx";

import styles from "./create-employee-page.module.css";

const HERO_CARD_BG = "/assets/images/onboarding-form-card-bg.png";

export default function CreateEmployeePage() {
  const isSqe = useSqeOnboardingApi();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [submitted, setSubmitted] = useState(false);

  return (
    <div className={styles.page} data-theme="caelius-classic">
      <header className={styles.topBar}>
        <img
          className={`${styles.logo} ${isSqe ? styles.sqeLogo : ""}`.trim()}
          src={isSqe ? "/assets/sqe-login/sqe_logo.svg" : "/assets/images/logo.svg"}
          alt={isSqe ? "SQE Labs" : "Caelius Consulting Logo"}
          width={isSqe ? 110 : 150}
        />
      </header>
      <main className={styles.main}>
        <div className={styles.inner}>
          {!submitted ? (
            <section
              className={styles.heroCard}
              style={{ backgroundImage: `url(${HERO_CARD_BG})` }}
              aria-labelledby="create-employee-page-title"
            >
              <h1 id="create-employee-page-title" className={styles.heroTitle}>
                {isSqe ? "Hello & Welcome to SQE Labs!" : "Hello & Welcome to Caelius Consulting!"}

              </h1>
              <div className={styles.heroLine} aria-hidden />
              <p className={`body-sm ${styles.heroIntro}`}>
                We’re delighted to have you on board. Please provide the required details to ensure a smooth and seamless onboarding journey.
              </p>
            </section>
          ) : null}
          {!token ? (
            <p className={`body-sm ${styles.error}`} role="alert">
              This page must be opened using the link from your onboarding email (it should include a
              token in the URL).
            </p>
          ) : (
            <CreateEmployeeWizard token={token} onSubmitted={() => setSubmitted(true)} />
          )}
        </div>
      </main>
    </div>
  );
}
